import CancelIcon from '@mui/icons-material/Cancel'
import { Chip, styled } from '@mui/material'

export const Tag = styled(Chip)(({ theme }) => ({
  paddingTop: 4,
  paddingBottom: 4,

  backgroundColor: theme.palette.grey[50],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: theme.palette.grey[600],
  padding: '6px 12px',
  paddingRight: 6,

  marginBottom: theme.spacing(1),
  zIndex: 1,
  margin: 0,

  '&:not(:last-of-type)': {
    marginRight: theme.spacing(1),
  },

  '& .MuiChip-label': {
    paddingLeft: 0,
    paddingRight: 0,
    marginRight: 8,
    lineHeight: '20px',
    fontSize: '17px',
  },
}))

export const DeleteIcon = styled(CancelIcon)(() => ({
  fontSize: 18,
  color: 'rgba(0, 0, 0, 0.6)',
  marginTop: 2,
  marginRight: 0,
  marginLeft: 0,
}))
